import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=387499c2&scoped=true"
import script from "./clock.vue?vue&type=script&lang=js"
export * from "./clock.vue?vue&type=script&lang=js"
import style0 from "./clock.vue?vue&type=style&index=0&id=387499c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387499c2",
  null
  
)

export default component.exports